import { COMPACT_MAX_WIDTH } from './dom.js';

const DRAWER_ROOT_SELECTOR = '[data-bp-drawer-runtime="v2"]';
const BURGER_SELECTOR = '[data-bp-burger]';
const DRAWER_SELECTOR = '[data-bp-drawer]';
const READY_ATTRIBUTE = 'data-bp-drawer-ready';
const READY_VALUE = 'true';
const OPEN_CLASS = 'is-open';

function initializeDrawer(root, documentObject, windowObject) {
  if (root.getAttribute(READY_ATTRIBUTE) === READY_VALUE) return false;

  const burger = root.querySelector(BURGER_SELECTOR);
  const drawer = root.querySelector(DRAWER_SELECTOR);
  if (!burger || !drawer) return false;

  const setOpen = (open) => {
    if (open) {
      burger.classList.add(OPEN_CLASS);
      drawer.classList.add(OPEN_CLASS);
    } else {
      burger.classList.remove(OPEN_CLASS);
      drawer.classList.remove(OPEN_CLASS);
    }
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  };

  burger.addEventListener('click', (event) => {
    event.preventDefault();
    setOpen(!drawer.classList.contains(OPEN_CLASS));
  });

  documentObject.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !drawer.classList.contains(OPEN_CLASS)) return;
    setOpen(false);
    burger.focus();
  });

  // Capture phase: controls that stop their click bubbling (the rail arrows) must still count as an outside click.
  documentObject.addEventListener('click', (event) => {
    if (!drawer.classList.contains(OPEN_CLASS)) return;
    if (drawer.contains(event.target) || burger.contains(event.target)) return;
    setOpen(false);
  }, { capture: true });

  windowObject.addEventListener('resize', () => {
    if (windowObject.innerWidth > COMPACT_MAX_WIDTH && drawer.classList.contains(OPEN_CLASS)) {
      setOpen(false);
    }
  });

  root.setAttribute(READY_ATTRIBUTE, READY_VALUE);
  return true;
}

export function initializeDrawers(root = document, environment = {}) {
  const documentObject = environment.document ?? root.ownerDocument ?? globalThis.document;
  const windowObject = environment.window ?? documentObject?.defaultView ?? globalThis.window;
  if (!root || !documentObject || !windowObject) return 0;

  if (root.matches?.(DRAWER_ROOT_SELECTOR)) {
    return initializeDrawer(root, documentObject, windowObject) ? 1 : 0;
  }

  let initialized = 0;
  for (const drawerRoot of root.querySelectorAll?.(DRAWER_ROOT_SELECTOR) ?? []) {
    if (initializeDrawer(drawerRoot, documentObject, windowObject)) initialized += 1;
  }
  return initialized;
}
